<section class="legal-info-panel">
  <app-terms-and-conditions-panel [noPadding]="true" />
</section>
